// LocalBusiness JSON-LD for The Cosmic Finder.
//
// Privacy: address is intentionally city/region only — no street/postal.
// Sarah's Google Business Profile has the full address on file (currently
// in storefront mode); the app deliberately publishes a narrower public
// signal to avoid leaking the home address through the website.
//
// SEO purpose: tells Google "the entity at app.thecosmicfinder.com is a
// Reno, NV oracle/astrology service". Combined with matching brand
// references on the linked external profiles (sameAs), this reinforces
// the same business identity Sarah's GBP already establishes locally.

const SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'The Cosmic Finder',
  description:
    'Oracle card readings, astrological weather, moon-phase practice, and personal sessions with creators — founded by Sarah McCallum in Reno, NV.',
  url: 'https://app.thecosmicfinder.com',
  image: 'https://app.thecosmicfinder.com/og-image.png',
  priceRange: '$',
  areaServed: {
    '@type': 'City',
    name: 'Reno',
    containedInPlace: { '@type': 'State', name: 'Nevada' },
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Reno',
    addressRegion: 'NV',
    addressCountry: 'US',
  },
  knowsAbout: [
    'Oracle card reading',
    'Akashic Records reading',
    'Past life healing',
    'Astrology',
    'Natal chart reading',
    'Astrological consulting',
    'Lunar nodes',
    'Moon phases',
    'Kairos healing',
    'Spiritual guidance',
    'Breathwork',
    'Trauma-informed breathwork',
  ],
  sameAs: [
    'https://www.thecosmicfinder.com/',
    'https://www.facebook.com/thecosmicfinder/',
    'https://www.instagram.com/thecosmicfinder/',
    'https://youtube.com/@thecosmicfinder',
  ],
}

export function LocalBusinessSchema() {
  return (
    <script
      type="application/ld+json"
      // JSON.stringify is safe — no untrusted user content in the schema constant.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(SCHEMA) }}
    />
  )
}
